
window.Vue = require('vue');

require('./bootstrap');
require('./mixins')

import vDialog from 'v-dialogs';
Vue.use(vDialog, {dialogMaxButton: false, dialogCloseButton: false, language: 'en', title: ''});

import DatePicker from "vue2-datepicker";
Vue.use(DatePicker)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import Tabs from 'vue-tabs-component';
Vue.use(Tabs);
Vue.config.ignoredElements = [/ion-icon/];

Vue.component('push-sender', require('./components/PushSender.vue').default);
Vue.component('product-editor', require('./components/ProductEditor.vue').default);
Vue.component('order-items-editor', require('./components/OrderItemsEditor.vue').default);
Vue.component('training-videos-editor', require('./components/TrainingVideosEditor.vue').default);
Vue.component('settings-editor', require('./components/SettingsEditor.vue').default);
Vue.component('quotes-page', require('./components/quotes/QuotesPage.vue').default);

import CategoriesDiscounts from "./components/CategoriesDiscounts.vue";

// Register the component globally
Vue.component('category-discounts', CategoriesDiscounts);

$(document).on('click', 'a[role=tab]',function(e){
	e.preventDefault();
})

import store from './store';

const app = new Vue({
	// router,
	store,
	el: '#app',
});
